








































































import Vue from 'vue'
import { isInteger } from 'lodash'
import mixins from 'vue-typed-mixins'
import TreatmentMixin from '@/views/treatment/TreatmentMixin'

export default mixins(TreatmentMixin).extend({
  computed: {
    letterNumber(): number {
      return this.breadcrumb || parseInt(this.letter.substring(1)) - 1
    },
    earliestSecondTime(): Date {
      const earliestSecondTime = new Date(this.nextSessionStartInDays)
      earliestSecondTime.setDate(earliestSecondTime.getDate() + this.minGap)
      return earliestSecondTime
    },
    earliestSecondDate(): Date {
      const earliestSecondDate = new Date(this.earliestSecondTime)
      earliestSecondDate.setHours(0, 0, 0, 0)
      return earliestSecondDate
    },
    latestFirstTime(): Date {
      const latestFirstDate = new Date()
      latestFirstDate.setDate(latestFirstDate.getDate() + this.maxDays - this.minGap)
      return latestFirstDate
    },
    latestFirstDate(): Date {
      const latestFirstDate = new Date(this.latestFirstTime)
      latestFirstDate.setHours(0, 0, 0, 0)
      return latestFirstDate
    },
  },
  props: {
    days: {
      type: Number,
      validator: isInteger,
      default: 2,
    },
    minDays: {
      type: Number,
      default: 2,
    },
    maxDays: {
      type: Number,
      default: 20,
    },
    minGap: {
      type: Number,
      default: 2,
    },
    letter: {
      type: String,
      required: true,
    },
    breadcrumb: {
      type: Number,
    },
  },
  data() {
    const firstDate = new Date()
    const secondDate = new Date()
    firstDate.setDate(firstDate.getDate() + this.days)
    secondDate.setDate(secondDate.getDate() + this.days + this.minGap)
    return {
      nextSessionStartInDays: firstDate,
      secondSessionStartInDays: secondDate,
    }
  },
  watch: {
    nextSessionStartInDays(value: Date): void {
      if (this.secondSessionStartInDays < this.earliestSecondTime) {
        this.secondSessionStartInDays = this.earliestSecondTime
      }
    },
  },
})
